// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"752":"b5bac1a4","799":"91ed2428","945":"7553f1d7"}[chunkId] + ".js";
};